import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconInfoSimple: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"info-simple, tooltip, information"} maskId="square-filled-radius-0-stroke-1-IconInfoSimple"><path d="M12.5 19H15V20H9V19H11.5V10H9V9H12.5V19Z" fill="currentColor"/><path d="M12 4C12.5523 4 13 4.44772 13 5C13 5.55228 12.5523 6 12 6C11.4477 6 11 5.55228 11 5C11 4.44772 11.4477 4 12 4Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconInfoSimple;
